
// import React from 'react';
// import { detailsFooter, detailsSocial, detailsDonate } from '../../data/Data';
// import './Footer.css';

// export default function Footer() {
//     return (
//         <footer className="footer">
//             {/* Left Column: Footer Details */}
//             <div className="footer__left">
//                 {detailsFooter.map((item) => (
//                     <div key={item.id} className="footer__item">
//                         <h4 className="footer__title">{item.title}</h4>
//                         <p className="footer__text">{item.status}</p>
//                     </div>
//                 ))}
//             </div>

//             {/* Right Column: Donate Button and Social Links */}
//             <div className="footer__right">
//                 <div className="footer__donate">
//                     {detailsDonate.map((item) => (
//                         <a
//                             key={item.id}
//                             id={item.id}
//                             className="footer__donate-button"
//                             href={item.href}
//                             style={item.style}
//                         >
//                             {item.donate}
//                         </a>
//                     ))}
//                 </div>
//                 <div className="footer__social">
//                     {detailsSocial.map((item) => (
//                         <a
//                             key={item.id}
//                             href={item.link}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="footer__social-link"
//                         >
//                             <img src={item.icon} alt="social-icon" className="footer__icon" />
//                         </a>
//                     ))}
//                 </div>
//             </div>
//         </footer>
//     );
// }

// 

// import React, { useState, useEffect } from 'react';
// import { detailsFooter, detailsSocial, detailsDonate } from '../../data/Data';
// import './Footer.css';

// export default function Footer() {
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     if (showModal) {
//       const scriptId = 'give-lively-script';
//       // Only add script if not already added
//       if (!document.getElementById(scriptId)) {
//         const script = document.createElement('script');
//         script.id = scriptId;
//         script.src = 'https://secure.givelively.org/widgets/branded_donation/national-aphasia-synergy-inc.js';
//         script.async = true;
//         document.getElementsByTagName('head')[0].appendChild(script);
//       }
//     }
//   }, [showModal]);

//   const openModal = () => setShowModal(true);
//   const closeModal = () => setShowModal(false);

//   return (
//     <>
//       <footer className="footer">
//         {/* Left Column: Footer Details */}
//         <div className="footer__left">
//           {detailsFooter.map((item) => (
//             <div key={item.id} className="footer__item">
//               <h4 className="footer__title">{item.title}</h4>
//               <p className="footer__text">{item.status}</p>
//             </div>
//           ))}
//         </div>

//         {/* Right Column: Donate Button and Social Links */}
//         <div className="footer__right">
//           <div className="footer__donate">
//             <button
//               onClick={openModal}
//               className="footer__donate-button"
//               style={{
//                 backgroundColor: '#00AEEF',
//                 color: '#fff',
//                 padding: '12px 24px',
//                 borderRadius: '6px',
//                 fontWeight: 'bold',
//                 border: 'none',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//               }}
//             >
//               Donate
//             </button>
//           </div>
//           <div className="footer__social">
//             {detailsSocial.map((item) => (
//               <a
//                 key={item.id}
//                 href={item.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="footer__social-link"
//               >
//                 <img src={item.icon} alt="social-icon" className="footer__icon" />
//               </a>
//             ))}
//           </div>
//         </div>
//       </footer>

//       {/* Donation Modal */}
//       {showModal && (
//         <div className="donation-modal-overlay">
//           <div className="donation-modal">
//             <button className="donation-modal-close" onClick={closeModal}>
//               &times;
//             </button>
//             <div
//               data-widget-src="https://secure.givelively.org/donate/national-aphasia-synergy-inc?ref=sd_widget"
//               id="give-lively-widget"
//               className="gl-branded-donation-widget"
//             ></div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useState, useEffect } from 'react';
import { detailsFooter, detailsSocial, detailsDonate } from '../../data/Data';
import './Footer.css';

export default function Footer() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      const scriptId = 'give-lively-script';
      // Only add script if not already added
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://secure.givelively.org/widgets/branded_donation/national-aphasia-synergy-inc.js';
        script.async = true;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }, [showModal]);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // Get the donate button config from detailsDonate
  const donateConfig = detailsDonate.find(item => item.id === 'gLively-donate-btn');

  return (
    <>
      <footer className="footer">
        {/* Left Column: Footer Details */}
        <div className="footer__left">
          {detailsFooter.map((item) => (
            <div key={item.id} className="footer__item">
              <h4 className="footer__title">{item.title}</h4>
              <p className="footer__text">{item.status}</p>
            </div>
          ))}
        </div>

        {/* Right Column: Donate Button and Social Links */}
        <div className="footer__right">
          <div className="footer__donate">
            <button
              onClick={openModal}
              className="footer__donate-button"
              style={donateConfig?.style}
            >
              {donateConfig?.donate || 'Donate'}
            </button>
          </div>
          <div className="footer__social">
            {detailsSocial.map((item) => (
              <a
                key={item.id}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
              >
                <img src={item.icon} alt="social-icon" className="footer__icon" />
              </a>
            ))}
          </div>
        </div>
      </footer>

      {/* Donation Modal */}
      {showModal && (
        <div className="donation-modal-overlay">
          <div className="donation-modal">
            <button className="donation-modal-close" onClick={closeModal}>
              &times;
            </button>
            <div
              data-widget-src="https://secure.givelively.org/donate/national-aphasia-synergy-inc?ref=sd_widget"
              id="give-lively-widget"
              className="gl-branded-donation-widget"
            ></div>
          </div>
        </div>
      )}
    </>
  );
}